import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { commonFetchData, updateQueryParams } from "../utils/commanFunctions";
import SingleCardNew from "./common/SingleCardNew";
import NoDataFoundSmall from "./common/NoDataFoundSmall";
import SeeAllButton from "./common/Buttons/SeeAllButton";
import configs from "../contentConfig";



const SkeletonItem = () => (
  <div className="animate-pulse flex flex-col space-y-2 min-w-[200px] max-w-[200px]">
    <div className="h-[150px] bg-gray-300 rounded"></div>
    <div className="h-4 bg-gray-300 rounded w-3/4"></div>
    <div className="h-3 bg-gray-300 rounded w-1/2"></div>
  </div>
);

const SkeletonLoader = () => (
  <div
    style={{
      padding: "24px 0px 32px 16px",
      background: "#eeeeee",
    }}
  >
    {[1].map((group) => (
      <div
        key={group}
        className="flex flex-col items-start gap-4 px-4 py-0 self-stretch w-full relative flex-[0_0_auto] "
      >
        <div className="flex items-end justify-between relative self-stretch w-full flex-[0_0_auto]">
          <div className="h-6 bg-gray-300 rounded w-1/3"></div>
          <div className="h-4 bg-gray-300 rounded w-1/6"></div>
        </div>
        <div className="flex items-start gap-4 self-stretch w-full overflow-x-scroll relative flex-[0_0_auto] min-h-[225px] no-scrollbar">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
            <SkeletonItem key={item} />
          ))}
        </div>
      </div>
    ))}
  </div>
);

const SingleRowComponent = (props) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const {subLayout = "v1",attachClass = "",size="small"} = props

  const params = new URLSearchParams(location.search);

  // const apiParams = params.get('apiParams')
  const apiParams =
    params.get("apiParams") || localStorage.getItem("apiParams");

  // // Effect to save parameters in localStorage
  // useEffect(() => {
  //   const paramMap = { server, hotel: hotelCode, reservation_id: reservationId, key: apiKey, guideUrl, primaryColor, user_id };
  //   for (const key in paramMap) {
  //     if (paramMap[key]) localStorage.setItem(key, paramMap[key]);
  //   }
  // }, [location.search]);

  // Effect to fetch data
  useEffect(() => {
    if (!apiParams) {
      setIsLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setIsLoading(true);
        // const apiParamsObj = Object.fromEntries(new URLSearchParams(apiParams));
        // const { id } = apiParamsObj;
        if (!apiParams) {
          setIsLoading(false);
          return;
        }

        const fetchedData = await commonFetchData(
          `/planner/places-events/groups/?${apiParams}`,
          {
            req: "get",
            onErrorData: [],
          }
        );

        setData(fetchedData);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [apiParams]);

  // Click handler
  const handleClick = (item, eventInfo = null) => {
    const origin = window.location.origin;
    const server = localStorage.getItem("server");
    const hotelCode = localStorage.getItem("hotel");
    const reservationId = localStorage.getItem("reservation_id");
    const primaryColor = localStorage.getItem("primaryColor");
    const apiKey = localStorage.getItem("key");
    // const apiParams = localStorage.getItem('apiParams')

    const consUrl = (url) =>
      `${origin}${url}&hotel=${hotelCode}&reservation_id=${reservationId}&primaryColor=${primaryColor}&key=${apiKey}&server=${server}&v=${process.env.REACT_APP_VERSION}&is_embedded_in_parent=1`;

    const eventData = eventInfo || {
      type: "INNSPIRE_ROUTE_TO",
      payload: {
        app_route: `/iframe-Renderer`,
        metaData: { widgetMetaHtmlId: "trip_planner_widget" },
        // url:`/?path=description&ID=${item.id}`,
        url: updateQueryParams({
          path: "description",
          ID: item.id,
        }),
      },
    };

    eventData.payload.url = consUrl(eventData?.payload?.url);
    console.log(eventData);
    window.top.postMessage(eventData, "*");
  };

  if (isLoading) {
    return <SkeletonLoader />;
  }

  return (
    <div
      style={{
        padding: "24px 0px 32px 16px",
        background: "#eeeeee",
      }}
      className={`${attachClass} singleRow-main-container`}
    >
      {data.length > 0 ? (
        data.map((group, index) => (
          <div
            key={index}
            className="flex flex-col items-start gap-4 py-0 self-stretch w-full relative flex-[0_0_auto] "
          >
            {/* <div className="flex items-end justify-between relative self-stretch w-full flex-[0_0_auto]">
            <div className="relative w-fit mt-[-1px] font-semibold text-black text-xl leading-[23px]">
              {group.name}
            </div>
      
          </div> */}
            <div className="flex items-end justify-between relative self-stretch w-full flex-[0_0_auto]">
              <div class="h-8 w-[94px] group-name">
                <span class="text-[var(--wwwstanfordcourtcomblack)] text-[32px] font-normal leading-8 tracking-normal whitespace-nowrap text-center">
                  {group.name}
                </span>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  const ev = {
                    type: "INNSPIRE_ROUTE_TO",
                    payload: {
                      app_route: `/iframe-Renderer`,
                      metaData: { widgetMetaHtmlId: "trip_planner_widget" },
                      // url: `/?path=seeAll&title=${group.name}&type=group&apiParams=${apiParams}`,
                      url: updateQueryParams({
                        path: "seeAll",
                        title: group.name,
                        type: "group",
                        apiParams: `id=${group.id}`,
                      }),
                    },
                  };
                  handleClick(group, ev);
                }}
                className="mr-4 cursor-pointer relative w-fit font-secondary font-normal text-[#666666] text-sm tracking-[0] leading-[16.1px] whitespace-nowrap"
              >
                  <SeeAllButton size={size}/>
              </div>
            </div>
            <div className={`flex items-start gap-4 self-stretch w-full overflow-x-scroll relative flex-[0_0_auto] min-h-[240px] no-scrollbar`}>
              {group?.event_or_place_list?.map((event, idx) => (
                <SingleCardNew
                  handleClick={() => handleClick(event)}
                  key={idx}
                  data={event}
                  groupData={group}
                  // size="large"
                  size={size || "small"}
                  subLayout={subLayout}
                  parentClassSelector={`parent-${size}-singleRow-card parent-single-row-comonent`}
                />
              ))}
            </div>
          </div>
        ))
      ) : (
        <NoDataFoundSmall />
      )}
    </div>
  );
};

export default SingleRowComponent;
